<template>
  <div v-if="createdBy" class="row mt-3">
    <div class="col text-start text-body-secondary">تم إضافة هذا العقار بواسطة: {{ createdBy }}</div>
  </div>
  <div v-if="dataRow && dataRow.deletedAt" class="row mt-3">
    <div class="col">
      <div class="alert alert-warning">هذا العقار تم حذفه بواسطة المالك بتاريخ {{ $shortDate(dataRow.deletedAt) }}</div>
    </div>
  </div>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <mainLoader v-if="mainLoading" />
      <!--begin::Body-->
      <div class="card-body">
        <div class="row steps-container">
          <div class="col" v-for="(title, index) in stepTitles" :key="index">
            <div class="steps" @click="jumbToStep(index + 1)">
              <span :class="{ active: step === index + 1, 'marketing-step': index === 9 }">
                <i v-if="index === 9" class="bi bi-megaphone-fill ms-1"></i>
                {{ title }}
                <small v-if="index === 9" class="marketing-step-count">3</small>
              </span>
            </div>
          </div>
        </div>
        <!-- owner type -->
        <div v-if="step == 1">
          <div v-if="dataRow.Project" class="mb-3">
            <label class="form-label">المشروع العقاري:</label>
            <div>
              <router-link v-if="checkAccess('projects_read')" :to="`/projects/update/${dataRow.Project.id}`">{{ dataRow.Project.title }}</router-link>
              <span v-else>{{ dataRow.Project.title }}</span>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-12 col-sm-6">
                <label class="form-label" for="">العميل:</label>
                <div>{{ userMobile }}</div>
              </div>
              <div class="col-12 col-sm-6">
                <loader v-if="userLoader" />
                <div v-if="userName">
                  <label class="form-label" for="">اسم العميل:</label>
                  <div>{{ userName }}</div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="mb-3">
            <label class="form-label" for="">نوع المالك:</label>
            <div>{{ ownerTypeList[ownerType] }}</div>
          </div>
          <div v-if="dataRow" class="mb-3">
            <label class="form-label" for="">مصدر الطلب:</label>
            <div>
              <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">Admin</span>
              <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">IOS</span>
              <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
              <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">Website</span>
              <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
              <span v-else class="text-muted">غير محدد</span>
            </div>
          </div>
        </div>
        <!-- owner data -->
        <div v-if="step == 2">
          <!-- owner -->
          <div v-if="ownerType == 'owner'">
            <div class="mb-3">
              <label for="" class="form-label">صورة الصك:</label>
              <img v-if="uploadedReceipt" :src="MEDIA_URL+uploadedReceipt" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم الصك:</label>
              <div>{{ receiptNumber }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">تاريخ الصك:</label>
              <div>{{ $shortDate(receiptDate) }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم هوية المالك:</label>
              <div>{{ ownerIdentity }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">تاريخ ميلاد المالك:</label>
              <div>{{ $shortDate(ownerDOB) }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم جوال المالك:</label>
              <div>{{ ownerMobile }}</div>
            </div>
          </div>
          <!-- agent -->
          <div v-if="ownerType == 'agent'">
            <div class="mb-3">
              <label for="" class="form-label">صورة الصك:</label>
              <img v-if="uploadedReceipt" :src="MEDIA_URL+uploadedReceipt" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم الصك:</label>
              <div>{{ receiptNumber }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">تاريخ الصك:</label>
              <div>{{ $shortDate(receiptDate) }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم هوية المالك:</label>
              <div>{{ ownerIdentity }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">تاريخ ميلاد المالك:</label>
              <div>{{ $shortDate(ownerDOB) }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم هوية الوكيل:</label>
              <div>{{ agentIdentity }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم الوكالة:</label>
              <div>{{ agencyNumber }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">تاريخ الوكالة:</label>
              <div>{{ $shortDate(agencyDate) }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">تاريخ ميلاد الوكيل:</label>
              <div>{{ $shortDate(agentDOB) }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم جوال الوكيل:</label>
              <div>{{ agentMobile }}</div>
            </div>
          </div>
          <!-- broker -->
          <div v-if="ownerType == 'broker'">
            <div class="mb-3">
              <label for="" class="form-label">رقم رخصة فال:</label>
              <div>{{ falLicense }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم ترخيص الاعلان:</label>
              <div>{{ adLicenseNumber }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">صورة الصك:</label>
              <img v-if="uploadedReceipt" :src="MEDIA_URL+uploadedReceipt" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم الصك:</label>
              <div>{{ receiptNumber }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">تاريخ الصك:</label>
              <div>{{ $shortDate(receiptDate) }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">تاريخ ميلاد المالك:</label>
              <div>{{ $shortDate(ownerDOB) }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم جوال المالك:</label>
              <div>{{ ownerMobile }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم هوية الوكيل:</label>
              <div>{{ agentIdentity }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم الوكالة:</label>
              <div>{{ agencyNumber }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">تاريخ ميلاد الوكيل:</label>
              <div>{{ $shortDate(agentDOB) }}</div>
            </div>
            <div class="mb-3">
              <label for="" class="form-label">رقم جوال الوكيل:</label>
              <div>{{ agentMobile }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col"><hr></div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">صورة هوية المالك:</label>
              <img v-if="uploadedIdentityImage" :src="MEDIA_URL+uploadedIdentityImage" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">صورة رخصة البناء:</label>
              <img v-if="uploadedBuildingPermitImage" :src="MEDIA_URL+uploadedBuildingPermitImage" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">صورة شهادة الدفاع المدني:</label>
              <img v-if="uploadedDefenseCertificateImage" :src="MEDIA_URL+uploadedDefenseCertificateImage" class="img-thumbnail" style="max-width: 200px;" alt="">
            </div>
          </div>
        </div>
        <!-- property data -->
        <div v-if="step == 3">
          <div class="row">
            <div class="col">
              <div class="form-head"><i class="bi bi-chevron-left"></i> البيانات الاساسية:</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">تصنيف العقار: <span class="req">*</span></label>
              <div>{{ categoryList[category] }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الغرض من الإعلان: <span class="req">*</span></label>
              <div>{{ purposeList[purpose] }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">نوع العقار: <span class="req">*</span></label>
              <div>{{ (dataRow.PropertyType)? dataRow.PropertyType.name : 'غير معروف' }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">السعر:</label>
              <div>{{ price }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">وصف مختصر: <span class="req">*</span></label>
              <div>{{ title }}</div>
              <div class="mt-3">
                <label for="" class="form-label">وصف مختصر (مترجم):</label>
                <div>{{ dataRow.titleEn }}</div>
              </div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الوصف: <span class="req">*</span></label>
              <div><pre>{{ description }}</pre></div>
              <div class="mt-3">
                <label for="" class="form-label">الوصف (مترجم):</label>
                <div><pre>{{ dataRow.descriptionEn }}</pre></div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-head"><i class="bi bi-chevron-left"></i> بيانات العنوان:</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">المنطقة: <span class="req">*</span></label>
              <div>{{ (dataRow.Region)? dataRow.Region.name : 'غير معروف' }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">المدينة: <span class="req">*</span></label>
              <div>{{ (dataRow.City)? dataRow.City.name : 'غير معروف' }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الحي: <span class="req">*</span></label>
              <div>{{ (dataRow.Neighborhood)? dataRow.Neighborhood.name : 'غير معروف' }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الشارع:</label>
              <div>{{ street }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مساحة العقار:</label>
              <div>{{ area }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الموقع على الخريطة:</label>
              <div ref="myMap" style="width: 100%; height: 350px;"></div>
              <div class="row pt-2">
                <div class="col">
                  <label for="" class="form-label">خط العرض - latitude</label>
                  <div>{{ latitude }}</div>
                </div>
                <div class="col">
                  <label for="" class="form-label">خط الطول - longitude</label>
                  <div>{{ longitude }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-head"><i class="bi bi-chevron-left"></i> البيانات الإضافة:</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">الواجهة:</label>
              <div>{{ (dataRow.ExchangeFront)? dataRow.ExchangeFront.name : 'غير معروف' }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">هل يوجد أي التزام على العقار؟:</label>
              <div>{{ (dataRow.hasObligations)? 'نعم' : 'لا' }}</div>
            </div>
          </div>

          <div class="row">
            <div v-if="currentTypeFields.indexOf('propertyType') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">نوع الساكن: <span class="req">*</span></label>
              <div>{{ (propertyType)? (propertyType == 'singles')? 'عزاب' : 'عوائل' : 'غير محدد' }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('buildNumber') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">رقم المبنى:</label>
              <div>{{ buildNumber }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('floorNumber') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">رقم الطابق:</label>
              <div>{{ floorNumber }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('apartmentNumber') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">رقم الشقة:</label>
              <div>{{ apartmentNumber }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('floorsCount') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الطوابق:</label>
              <div>{{ floorsCount }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('roomsCount') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الغرف:</label>
              <div>{{ roomsCount }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('bathrooms') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الحمامات:</label>
              <div>{{ bathrooms }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('furnished') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مؤثث:</label>
              <div>{{ (dataRow.furnished)? 'نعم' : 'لا' }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('saudiBuildingCode') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مطابق لكود البناء السعودي؟:</label>
              <div>{{ (dataRow.saudiBuildingCode)? 'نعم' : 'لا' }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('plotNumber') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">رقم القطعة:</label>
              <div>{{ dataRow.plotNumber }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('halls') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عدد الصالات:</label>
              <div>{{ dataRow.halls }}</div>
            </div>
            <div v-if="currentTypeFields.indexOf('age') != -1" class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">عمر العقار:</label>
              <div>{{ (dataRow.age)? dataRow.age.name : 'غير محدد' }}</div>
            </div>
          </div>

          <div class="row">
            <div class="col-auto mb-3" v-for="featureData in dataRow.PropertyFeatures" :key="featureData.id">
              <div class="form-check">
                <label class="form-check-label">
                  <img v-if="featureData.icon" :src="MEDIA_URL+featureData.icon" class="rounded" style="max-width: 100px;" alt="">
                  {{ featureData.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- Property Additionals -->
        <div v-if="step == 4">
          <div v-if="!dataRow || !dataRow.id" class="alert alert-info">
            يجب حفظ العقار أولاً قبل إضافة البيانات الإضافية
          </div>

          <PropertyAdditionals
            v-else
            :propertyId="dataRow.id"
          />
        </div>
        <!-- images -->
        <div v-if="step == 5">
          <div class="row">
            <div class="col-12 col-sm-3 media-img-container" v-for="(img, indx) in mediaList" :key="indx">
              <img :src="MEDIA_URL+img.path" class="img-thumbnail img-fluid" alt="">
            </div>
          </div>
        </div>
        <!-- property details -->
        <div v-if="step == 6">
          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مندوب العقارية:</label>
              <div>{{ (dataRow.Agent)? dataRow.Agent.name : 'غير معين له مندوب' }}</div>
            </div>
            <!-- <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">مدة الإعلان:</label>
              <select class="form-control" v-model="adDuration">
                <option :value="period.val" v-for="(period, i) in durations" :key="i">{{ period.label }}</option>
              </select>
            </div> -->
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <div class="form-check">
                <label class="form-check-label" for="isFeatured1">
                  <i v-if="isFeatured" class="fa-regular fa-circle-check"></i>
                  <i v-else class="fa-regular fa-circle-xmark"></i>
                  الإعلان يصنف كإعلان مميز
                </label>
              </div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">قيمة الإعلان المميز:</label>
              <div>{{ featuredAmount }} {{ (isPayed)? 'مدفوعه' : 'غير مدفوعه' }}</div>
              <div class="form-text">في حالة كان الإعلان يصنف كإعلان مميز</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">حالة الإعلان:</label>
              <div>{{ statusChoices[status] }}</div>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <label for="" class="form-label">سبب رفض الإعلان:</label>
              <div>{{ rejectionNote }}</div>
              <div class="form-text">توضيح سبب رفض الإعلان في حالة كانت حالة الإعلان مرفوض</div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 mb-3">
              <div class="form-check">
                <label class="form-check-label" for="manageProperty">
                  <i v-if="manageProperty" class="fa-regular fa-circle-check"></i>
                  <i v-else class="fa-regular fa-circle-xmark"></i>
                  هل يتم إدارة هذا العقار من قبل شركة احمد المحيسني العقارية ؟
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- property managment -->
        <div v-if="step == 7">
          <div class="row" v-if="!manageProperty">
            <div class="col">
              <div class="alert alert-info">هذا العقار لا يتم إدارته من قبل شركة احمد المحيسني العقارية</div>
            </div>
          </div>
          <div v-if="manageProperty">
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label class="form-label" for="">{{ (purpose == 'for_rent')? 'المستأجر' : 'المالك' }} الحالي:</label>
                <div>{{ rentalMobile }}</div>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <loader v-if="rentalLoader" />
                <div v-if="rentalName">
                  <label class="form-label" for="">اسم العميل:</label>
                  <div>{{ rentalName }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">إجمالي سعر {{ (purpose == 'for_rent')? 'الإيجار' : 'البيع' }}:</label>
                <div>{{ finalPrice }}</div>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">العمولة العقارية:</label>
                <div>{{ commission }} {{ commissionType === 'fixed' ? 'ريال (مبلغ ثابت)' : '% (نسبة مئوية)' }}</div>
                <div class="form-check">
                  <label class="form-check-label" for="commissionCollected1">
                    <i v-if="commissionCollected" class="fa-regular fa-circle-check"></i>
                    <i v-else class="fa-regular fa-circle-xmark"></i>
                    تم تحصيل عمولة العقارية
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">تاريخ استلام العقار:</label>
                <div>{{ $shortDate(startDate) }}</div>
              </div>
            </div>
            <div v-if="purpose == 'for_rent'" class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">مدة الإيجار:</label>
                <div class="input-group">
                  <div>{{ rentalTerm }} {{ rentalUnitList[rentalUnit] }}</div>
                </div>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">تاريخ نهاية الإيجار:</label>
                <div>{{ $shortDate(rentExpire) }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">اجمالي المبلغ المحصل:</label>
                <div>{{ collectedAmount }}</div>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <label for="" class="form-label">اجمالي المبلغ المتبقي:</label>
                <div>{{ remainingPayments }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col"><hr></div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-head">الدفعات المالية:</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <div v-for="(pay , index) in propertyPayments" :key="index" class="row border-bottom pb-3 mb-3">
                  <div class="col-6 col-sm-3">
                    <label for="" class="form-label">المبلغ</label>
                    <div>{{ pay.amount }}</div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <label for="" class="form-label">تاريخ الإستحقاق</label>
                    <div>{{ $shortDate(pay.dueDate) }}</div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <label for="" class="form-label">تم السداد</label>
                    <div>{{ (pay.isPaid)? 'نعم' : 'لا' }}</div>
                  </div>
                  <div class="col-6 col-sm-2">
                    <label for="" class="form-label">تاريخ السداد</label>
                    <div>{{ $shortDate(pay.paymentDate) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 8">
          <PropertyAttachments v-if="dataRow" :propertyId="dataRow.id" />
        </div>
        <div v-if="step == 9">
          <div v-if="dataRow" class="row">
            <div class="col mb-5" id="validatorForm">
              <fieldset>
                <legend>التحقق من رقم ترخيص الإعلان:</legend>
                <div class="row">
                  <div class="col-6 col-sm-3">
                    <label class="form-label">رقم ترخيص الإعلان:</label>
                    <input type="text" class="form-control" v-model="validatorAdLicenseNumber">
                  </div>
                  <div class="col-6 col-sm-3">
                    <label class="form-label">نوع هوية المُعلن:</label>
                    <select class="form-control" v-model="validatorIdType">
                      <option value="1">رقم الهوية</option>
                      <option value="2">الرقم الموحد للمنشأة</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3">
                    <label class="form-label">رقم هوية المُعلن:</label>
                    <input type="text" class="form-control" v-model="validatorAdvertiserId">
                  </div>
                  <div class="col-6 col-sm-3 set-padding">
                    <button v-if="!regaValidateLoader" type="button" class="btn btn-warning btn-sm" @click.prevent="checkAdLicense"><i class="fa-solid fa-clipboard-check"></i> التحقق</button>
                    <loader v-if="regaValidateLoader" />
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="row">
              <div class="col text-end">
                <router-link :to="`/regaUpdate/create/${dataRow.id}`" class="btn btn-warning">ارسال تحديث إلى الهيئة</router-link>
              </div>
            </div>
          </div>
          <div v-if="!regaAdValidator" class="row mt-3">
            <div class="col">
              <div class="alert alert-warning">لم يتم التحقق من رقم ترخيص الإعلان لدى الهيئة العامة للعقار الآن ،،،</div>
            </div>
          </div>
          <div v-if="regaAdValidator" class="row">
            <div class="col">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <strong>يوجد ترخيص: </strong>{{ (regaAdValidator.isValid)? 'نعم' : 'لا' }}
                </div>
                <div v-if="regaAdValidator.message" class="col-12 col-sm-6">
                  <strong>رسالة الخطأ: </strong>{{ regaAdValidator.message }}
                </div>
              </div>
              <div v-if="regaAdValidator.advertisement" class="table-responsive">
                <table class="table table-striped">
                  <tbody>
                    <tr>
                      <th>رقم هوية المعلن:</th>
                      <td>{{ regaAdValidator.advertisement.advertiserId }}</td>
                      <th>رقم ترخيص الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.adLicenseNumber }}</td>
                    </tr>
                    <tr>
                      <th>رقم وثيقة الملكية / ملكية المنفعة:</th>
                      <td>{{ regaAdValidator.advertisement.deedNumber }}</td>
                      <th>اسم المعلن:</th>
                      <td>{{ regaAdValidator.advertisement.advertiserName }}</td>
                    </tr>
                    <tr>
                      <th>مسؤول الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.responsibleEmployeeName }}</td>
                      <th>رقم جوال مسؤول الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.responsibleEmployeePhoneNumber }}</td>
                    </tr>
                    <tr>
                      <th>رقم التواصل للمعلن:</th>
                      <td>{{ regaAdValidator.advertisement.phoneNumber }}</td>
                      <th>رقم رخصة الوساطة والتسويق العقاري:</th>
                      <td>{{ regaAdValidator.advertisement.brokerageAndMarketingLicenseNumber }}</td>
                    </tr>
                    <tr>
                      <th>وجود قيود؟:</th>
                      <td>{{ (regaAdValidator.advertisement.isConstrained)? 'نعم' : 'لا' }}</td>
                      <th>وجود رهن؟:</th>
                      <td>{{ (regaAdValidator.advertisement.isPawned)? 'نعم' : 'لا' }}</td>
                    </tr>
                    <tr>
                      <th>وجود وقف؟:</th>
                      <td>{{ (regaAdValidator.advertisement.isHalted)? 'نعم' : 'لا' }}</td>
                      <th>وجود وصية؟:</th>
                      <td>{{ (regaAdValidator.advertisement.isTestment)? 'نعم' : 'لا' }}</td>
                    </tr>
                    <tr>
                      <th>قيود السجل العيني:</th>
                      <td><pre>{{ regaAdValidator.advertisement.rerConstraints }}</pre></td>
                      <th>عرض الشارع:</th>
                      <td>{{ regaAdValidator.advertisement.streetWidth }}</td>
                    </tr>
                    <tr>
                      <th>مساحة العقار:</th>
                      <td>{{ regaAdValidator.advertisement.propertyArea }}</td>
                      <th>سعر الوحدة / سعر المتر للارض:</th>
                      <td>{{ regaAdValidator.advertisement.propertyPrice }}</td>
                    </tr>
                    <tr>
                      <th>اجمالي سعر بيع الارض:</th>
                      <td>{{ regaAdValidator.advertisement.landTotalPrice }}</td>
                      <th>اجمالي الإيجار السنوي للارض:</th>
                      <td>{{ regaAdValidator.advertisement.landTotalAnnualRent }}</td>
                    </tr>
                    <tr>
                      <th>عدد الغرف:</th>
                      <td>{{ regaAdValidator.advertisement.numberOfRooms }}</td>
                      <th>نوع العقار:</th>
                      <td>{{ regaAdValidator.advertisement.propertyType }}</td>
                    </tr>
                    <tr>
                      <th>عمر العقار:</th>
                      <td>{{ regaAdValidator.advertisement.propertyAge }}</td>
                      <th>غرض الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.advertisementType }}</td>
                    </tr>
                    <tr>
                      <th>العنوان:</th>
                      <td><pre>{{ regaAdValidator.advertisement.location }}</pre></td>
                      <th>واجهة العقار:</th>
                      <td>{{ regaAdValidator.advertisement.propertyFace }}</td>
                    </tr>
                    <tr>
                      <th>رقم المخطط:</th>
                      <td>{{ regaAdValidator.advertisement.planNumber }}</td>
                      <th>رقم القطعة:</th>
                      <td>{{ regaAdValidator.advertisement.landNumber }}</td>
                    </tr>
                    <tr>
                      <th>الإلتزامات على العقار:</th>
                      <td>{{ regaAdValidator.advertisement.obligationsOnTheProperty }}</td>
                      <th>الضمانات ومدتها:</th>
                      <td>{{ regaAdValidator.advertisement.guaranteesAndTheirDuration }}</td>
                    </tr>
                    <tr>
                      <th>مطابقة كود البناء السعودي:</th>
                      <td>{{ regaAdValidator.advertisement.complianceWithTheSaudiBuildingCode }}</td>
                      <th>قنوات الإعلان:</th>
                      <td><pre>{{ regaAdValidator.advertisement.channels }}</pre></td>
                    </tr>
                    <tr>
                      <th>استخدام العقار:</th>
                      <td><pre>{{ regaAdValidator.advertisement.propertyUsages }}</pre></td>
                      <th>نوع استخدام الارض:</th>
                      <td>{{ regaAdValidator.advertisement.mainLandUseTypeName }}</td>
                    </tr>
                    <tr>
                      <th>نوع منع التصرف:</th>
                      <td>{{ regaAdValidator.advertisement.redZoneTypeName }}</td>
                      <th>خدمات العقار:</th>
                      <td><pre>{{ regaAdValidator.advertisement.propertyUtilities }}</pre></td>
                    </tr>
                    <tr>
                      <th>تاريخ إنشاء ترخيص الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.creationDate }}</td>
                      <th>تاريخ إنتهاء ترخيص الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.endDate }}</td>
                    </tr>
                    <tr>
                      <th>رابط ترخيص الإعلان:</th>
                      <td><a :href="regaAdValidator.advertisement.adLicenseUrl" target="_blank">فتح الرابط</a></td>
                      <th>مصدر ترخيص الإعلان:</th>
                      <td>{{ regaAdValidator.advertisement.adSource }}</td>
                    </tr>
                    <tr>
                      <th>نوع وثيقة الملكية / نوع وثيقة المنفعة:</th>
                      <td>{{ regaAdValidator.advertisement.titleDeedTypeName }}</td>
                      <th>وصف موقع العقار حسب الصك:</th>
                      <td>{{ regaAdValidator.advertisement.locationDescriptionOnMOJDeed }}</td>
                    </tr>
                    <tr>
                      <th>الملاحظات:</th>
                      <td>{{ regaAdValidator.advertisement.notes }}</td>
                      <th>حدود واطوال العقار من وزارة العدل:</th>
                      <td><pre>{{ regaAdValidator.advertisement.borders }}</pre></td>
                    </tr>
                    <tr>
                      <th>حدود واطوال العقار من السجل العقاري:</th>
                      <td><pre>{{ regaAdValidator.advertisement.rerBorders }}</pre></td>
                      <th>رسوم نقل الملكية:</th>
                      <td><pre>{{ regaAdValidator.advertisement.ownershipTransferFeeType }}</pre></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 10 && checkAccess('property_banner_requests_read')">
          <PropertyMarketingMaterials v-if="dataRow" :propertyId="dataRow.id" :read-only="true" />
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-start">
            <button v-if="step > 1" type="button" class="btn btn-secondary" @click="prevStep"><i class="bi bi-arrow-bar-right"></i> السابق</button>
          </div>
          <div class="col text-end">
            <button v-if="step < stepTitles.length" type="button" class="btn btn-secondary" @click="nextStep">التالي <i class="bi bi-arrow-bar-left"></i></button>
          </div>
        </div>
      </div>
      <!--end::Footer-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { shortDate, checkAccess } from '@/helpers/tools';
import PropertyAttachments from '@/components/PropertyAttachments.vue';
import PropertyAdditionals from '@/components/PropertyAdditionals.vue'
import PropertyMarketingMaterials from '@/components/PropertyMarketingMaterials.vue';

export default {
  name: 'PropertiesView',
  components: { PropertyAttachments, PropertyAdditionals, PropertyMarketingMaterials },
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusChoices: {
      type: Object,
      default: {},
    },
  },
  data(){
    return {
      mainLoading: false,
      userLoader: false,
      mediaLoader: false,
      formLoader: false,
      rentalLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      step: 1,
      stepTitles: [
        "نوع المالك", 
        "بيانات المالك",
        "بيانات العقار",
        "بيانات إضافية",
        "الصور", 
        "تفاصيل الإعلان", 
        "إدارة العقار", 
        "مرفقات العقار",
        "هيئة العقار",
        ...(checkAccess('property_banner_requests_read') ? ["المواد التسويقية واللوحات"] : []),
      ],
      // for config
      userMobile: null,
      userName: null,
      uploadedReceipt: null,
      citiesList: [],
      neighborhoodsList: [],
      mediaList: [],
      createdBy: null,
      rentalMobile: null,
      rentalName: null,
      uploadedIdentityImage: null,
      uploadedBuildingPermitImage: null,
      uploadedDefenseCertificateImage: null,
      // for form owner
      userId: null,
      ownerType: "owner",
      receiptImage: null,
      receiptNumber: null,
      receiptDate: null,
      ownerIdentity: null,
      ownerDOB: null,
      ownerMobile: null,
      agentIdentity: null,
      agencyNumber: null,
      agencyDate: null,
      agentDOB: null,
      agentMobile: null,
      falLicense: null,
      adLicenseNumber: null,
      identityImage: null,
      buildingPermitImage: null,
      defenseCertificateImage: null,
      // for property form
      category: 'residential',
      purpose: 'for_sale',
      regionId: null,
      cityId: null,
      neighborhoodId: null,
      street: '',
      buildNumber: '',
      floorsCount: 0,
      floorNumber: 0,
      apartmentNumber: 0,
      typeId: null,
      title: '',
      description: '',
      price: 0,
      latitude: 24.7136,
      longitude: 46.6753,
      propertyType: null,
      area: 0,
      roomsCount: 0,
      bathrooms: 0,
      age: 0,
      agentId: null,
      status: 'available',
      manageProperty: true,
      adDuration: '1',
      isFeatured: false,
      rejectionNote: '',
      startDate: null,
      rentExpire: null,
      mediaIds: [],
      features: [],
      map: null,
      marker: null,
      // for property managment
      tenant: null,
      finalPrice: 0,
      collectedAmount: 0,
      remainingPayments: 0,
      rentalTerm: 0,
      rentalUnit: 'year',
      featuredAmount: 0,
      commission: 0,
      commissionCollected: false,
      isPayed: false,
      propertyPayments: [],
      ownerTypeList: {
        owner: 'مالك',
        agent: 'وكيل',
        broker: 'وسيط عقاري'
      },
      categoryList: {
        residential: 'سكني',
        commercial: 'تجاري',
        agricultural: 'زراعي',
      },
      purposeList: {
        for_sale: 'للبيع',
        for_rent: 'للإيجار',
        for_investment: 'للإستثمار', 
      },
      rentalUnitList: {
        day: 'يوم', 
        month: 'شهر', 
        year: 'سنوات', 
      },
      currentTypeFields: [],
      regaValidateLoader: false,
      regaAdValidator: null,
      validatorAdLicenseNumber: null,
      validatorIdType: null,
      validatorAdvertiserId: null,
      commissionType: 'percent',
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GOOGLE_MAP_API'])
  },
  methods: {
    checkAccess,
    prevStep(){
      this.step = this.step - 1;
      if(this.step == 3){
        this.initialGoogleMap();
      }
    },
    nextStep(){
      this.hasError = false;
      this.errorNumber = 0;
      this.step = this.step + 1;
      if(this.step == 3){
        this.initialGoogleMap();
      }
    },
    // google map 
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }

      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { lat: this.latitude ?? 24.7136, lng: this.longitude ?? 46.6753 },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    jumbToStep(stepNum){
      if(this.dataRow){
        this.step = stepNum;
        if(stepNum == 3){
          this.initialGoogleMap();
        }
      }
    },
    checkAdLicense(){
      this.regaValidateLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      if(!this.validatorIdType || !this.validatorAdLicenseNumber || !this.validatorAdvertiserId){
        this.message = 'كل البيانات مطلوبة';
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.regaValidateLoader = false;
        return;
      }

      this.$http.post(`/api/admin/properties/checkAd/${this.dataRow.id}`, {
        idType: this.validatorIdType,
        adLicenseNumber: this.validatorAdLicenseNumber,
        advertiserId: this.validatorAdvertiserId,
      }).then(({data}) => {
        this.regaAdValidator = data.result;
        this.regaValidateLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.regaValidateLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      // for config
      this.userMobile = this.dataRow.PropertyOwner.User.mobile;
      this.userName = this.dataRow.PropertyOwner.User.name;
      this.uploadedReceipt = this.dataRow.PropertyOwner.receiptImage;
      this.uploadedIdentityImage = this.dataRow.PropertyOwner.identityImage;
      this.uploadedBuildingPermitImage = this.dataRow.PropertyOwner.buildingPermitImage;
      this.uploadedDefenseCertificateImage = this.dataRow.PropertyOwner.defenseCertificateImage;
      if(this.dataRow.mediaFiles){
        this.dataRow.mediaFiles.map(m => {
          this.mediaList.push({
            id: m.id,
            path: m.filePath,
          });
          this.mediaIds.push(m.id);
        });
      }
      this.createdBy = (this.dataRow.Admin)? this.dataRow.Admin.name : null;
      // for form owner
      this.userId = this.dataRow.PropertyOwner.userId;
      this.ownerType = this.dataRow.PropertyOwner.ownerType;
      this.receiptNumber = this.dataRow.PropertyOwner.receiptNumber;
      this.receiptDate = (this.dataRow.PropertyOwner.receiptDate)? shortDate(this.dataRow.PropertyOwner.receiptDate) : null;
      this.ownerIdentity = this.dataRow.PropertyOwner.ownerIdentity;
      this.ownerDOB = (this.dataRow.PropertyOwner.ownerDOB)? shortDate(this.dataRow.PropertyOwner.ownerDOB) : null;
      this.ownerMobile = this.dataRow.PropertyOwner.ownerMobile;
      this.agentIdentity = this.dataRow.PropertyOwner.agentIdentity;
      this.agencyNumber = this.dataRow.PropertyOwner.agencyNumber;
      this.agencyDate = (this.dataRow.PropertyOwner.agencyDate)? shortDate(this.dataRow.PropertyOwner.agencyDate) : null;
      this.agentDOB = (this.dataRow.PropertyOwner.agentDOB)? shortDate(this.dataRow.PropertyOwner.agentDOB) : null;
      this.agentMobile = this.dataRow.PropertyOwner.agentMobile;
      this.falLicense = this.dataRow.PropertyOwner.falLicense;
      this.adLicenseNumber = this.dataRow.PropertyOwner.adLicenseNumber;
      // for property form
      this.category = this.dataRow.category;
      this.purpose = this.dataRow.purpose;
      this.regionId = this.dataRow.regionId;
      this.cityId = this.dataRow.cityId;
      this.neighborhoodId = this.dataRow.neighborhoodId;
      this.street = this.dataRow.street;
      this.buildNumber = this.dataRow.buildNumber;
      this.floorsCount = this.dataRow.floorsCount;
      this.floorNumber = this.dataRow.floorNumber;
      this.apartmentNumber = this.dataRow.apartmentNumber;
      this.typeId = this.dataRow.typeId;
      this.title = this.dataRow.title;
      this.description = this.dataRow.description;
      this.price = this.dataRow.price;
      this.latitude = (this.dataRow.latitude)? parseFloat(this.dataRow.latitude) : null;
      this.longitude = (this.dataRow.longitude)? parseFloat(this.dataRow.longitude) : null;
      this.propertyType = this.dataRow.propertyType;
      this.area = this.dataRow.area;
      this.roomsCount = this.dataRow.roomsCount;
      this.bathrooms = this.dataRow.bathrooms;
      this.age = this.dataRow.age;
      this.agentId = this.dataRow.agentId;
      this.status = this.dataRow.status;
      this.manageProperty = this.dataRow.manageProperty;
      this.adDuration = this.dataRow.adDuration;
      this.isFeatured = this.dataRow.isFeatured;
      this.rejectionNote = this.dataRow.rejectionNote;
      this.startDate = (this.dataRow.startDate)? shortDate(this.dataRow.startDate) : null;
      this.rentExpire = (this.dataRow.rentExpire)? shortDate(this.dataRow.rentExpire) : null;
      if(this.dataRow.PropertyFeatures){
        this.dataRow.PropertyFeatures.map(f => {
          this.features.push(f.id);
        })
      }
      if(this.dataRow.User){
        this.rentalMobile = this.dataRow.User.mobile;
        this.rentalName = this.dataRow.User.name;
      }
      this.tenant = this.dataRow.tenant;
      this.finalPrice = this.dataRow.finalPrice;
      this.collectedAmount = this.dataRow.collectedAmount;
      this.remainingPayments = this.dataRow.remainingPayments;
      this.rentalTerm = this.dataRow.rentalTerm;
      this.rentalUnit = this.dataRow.rentalUnit;
      this.featuredAmount = this.dataRow.featuredAmount;
      this.commission = this.dataRow.commission;
      this.commissionCollected = this.dataRow.commissionCollected;
      this.isPayed = this.dataRow.isPayed;
      this.commissionType = this.dataRow.commissionType || 'percent';
      // this.propertyPayments = this.dataRow.PropertyPayments ?? [];
      if(this.dataRow.PropertyPayments){
        this.dataRow.PropertyPayments.map(pay => {
          this.propertyPayments.push({
            id: pay.id,
            amount: pay.amount,
            dueDate: (pay.dueDate)? shortDate(pay.dueDate) : null,
            isPaid: pay.isPaid,
            paymentDate: (pay.paymentDate)? shortDate(pay.paymentDate) : null,
          });
        });
      }
      if(this.dataRow.PropertyType)
        this.currentTypeFields = this.dataRow.PropertyType.propertyFields ?? [];
    }
  }
}
</script>

<style scoped>
.steps-container {
  margin-bottom: 40px;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 8px;
}
.steps-container > .col { min-width: max-content; }
.steps {
  display: flex;
  justify-content: space-around;
  white-space: nowrap;
  font-weight: bold;
  cursor: pointer;
}

.steps span {
  padding: 5px 15px;
  border-bottom: 3px solid #ccc;
}

.steps .active {
  color: #007bff;
  border-bottom: 3px solid #007bff;
}
.steps .marketing-step.active {
  color: #176548;
  border-bottom-color: #176548;
}
.marketing-step-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 4px;
  border-radius: 50%;
  color: #fff;
  background: #176548;
  font-size: 11px;
}
</style>
